import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as alert from "../../../../redux/alertSnackBarRedux";
import * as proposalAttachmentService from "../../../../services/service/proposalAttachmentService";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import MUIDataTable from "mui-datatables";
import { Button, Modal, Form } from "react-bootstrap";
import { useFormik } from "formik";
import { getInputClasses, convertJsonToFormData, dateFilterListRenderer, dateFilterLogic } from "../../../../helpers/helper";
import * as confirmModal from "../../../../redux/confirmModalRedux";
import ProposalAttachmentValidator from '../../../../helpers/validators/ProposalAttachmentValidator';
import constants from "../../../../constants/constants";
import DateFilterComponent from "../../../components/DateFilterComponent"
import { FilePond, registerPlugin } from "react-filepond";
import { FormControlLabel } from '@material-ui/core';
import { Switch } from '@material-ui/core';
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);
const moment = require('moment');

const ProposalAttachmentPage = (props) => {
    const { showAlert, proposalId, showConfirmModal, hideConfirmModal, auth, isReadOnly } = props;
    var initialAttachment = {
        id: 0,
        proposalId: proposalId,
        name: '',
        description: '',
        uploadedFile: null,
        uploadedById: auth.user.id,
        sendToClient: false,
        uploadedDateTime: moment().format("MM/DD/yyyy hh:mm a")
    };

    const [editObj, setEditObj] = useState({
        id: -1,
        name: '',
        type: ''
    });
    const [data, setData] = useState([]);
    const [showIndex, setShowIndex] = useState(-1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedAttachment, setSelectedAttachment] = useState(initialAttachment);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploaded, setUploaded] = useState(0);
    const [uploading, setUploading] = useState(0)
    const [isMulti, setIsMulti] = useState(false)


    useEffect(() => {
        loadTableData();
    }, []);

    const loadTableData = () => {
        proposalAttachmentService.getProposalAttachments(proposalId).then(res => {
            setData(res);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const deleteAttachment = (attachmentId) => {
        proposalAttachmentService.deleteProposalAttachment(attachmentId).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            hideConfirmModal();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }

    const editAttachment = (attachmentId) => {
        proposalAttachmentService.getProposalAttachment(attachmentId).then(res => {
            var attachment = {
                id: res.id,
                proposalId: res.proposalId,
                name: res.name,
                description: res.description,
                uploadedFile: null,
                filePath: res.fileLocation,
                uploadedById: res.uploadedById,
                uploadedDateTime: res.uploadedDateTime,
                sendToClient: res.sendToClient
            };
            setSelectedAttachment(attachment);
            setFileList([...fileList, attachment])
            setIsModalOpen(true);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                setCellProps: () => ({
                    'data-aes-field': 'actions',
                    'data-aes-label': 'Actions',
                    style: { width: "28%" }
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="aes-admin-listing-actions">
                            <a
                                target="_blank"
                                href={constants.API_URL + data[dataIndex].fileLocation}
                                className="btn btn-sm btn-primary font-weight-bold py-2 px-3 px-xxl-5"
                            >
                                View
                            </a> &nbsp;
                            {!isReadOnly && <>
                                <button
                                    className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                    onClick={() => editAttachment(data[dataIndex].id)}
                                >
                                    Edit
                                </button> &nbsp;
                                <button
                                    onClick={() => showConfirmModal({
                                        title: "Delete Attachment",
                                        text: "Are you sure you want to delete this attachment?",
                                        rightBtnText: "Confirm",
                                        btnAction: () => deleteAttachment(data[dataIndex].id)
                                    })}
                                    className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                                >
                                    Delete
                                </button>
                            </>}
                        </div>
                    );
                }
            },

        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'file-name',
                    'data-aes-label': 'Name'
                }),
            }
        },
        {
            name: "uploadedBy",
            label: "Uploaded By",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'uploaded-by',
                    'data-aes-label': 'Uploaded By'
                }),
            }
        },
        {
            name: "uploadedDateTime",
            label: "Uploaded DateTime",
            options: {
                filter: true,
                sort: true,
                filterType: 'custom',
                setCellProps: () => ({
                    'data-aes-field': 'uploaded-date',
                    'data-aes-label': 'Uploaded DateTime'
                }),
                customFilterListRender: v => dateFilterListRenderer(v),
                filterOptions: {
                    names: [],
                    logic(date, filters) {
                        return dateFilterLogic(date, filters);
                    },
                    display: (filterList, onChange, index, column) => <DateFilterComponent
                        name={"Uploaded Date"}
                        filterList={filterList}
                        onChange={onChange}
                        index={index}
                        column={column}
                    />
                }
            }
        },
        {
            name: "fileExtension",
            label: "File Extension",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'file-type',
                    'data-aes-label': 'File Extension'
                }),
            }
        },
        {
            name: "sendToClient",
            label: "Send to Client?",
            options: {
                filter: true,
                sort: true,
                setCellProps: () => ({
                    'data-aes-field': 'send-to-client',
                    'data-aes-label': 'Send to Client?'
                }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <SVG
                                className="h-50 align-self-center"
                                src={toAbsoluteUrl(data[dataIndex].sendToClient ? "/media/svg/icons/Navigation/Check.svg" : "/media/svg/icons/Navigation/Close.svg")}
                            >
                            </SVG>
                        </>
                    );
                }
            }
        }
    ];


    const handleModalClose = () => {
        setEditObj({
            id: -1,
            name: ''
        });
        setUploading(0);
        setUploaded(0);
        setIsModalOpen(false);
        setSelectedAttachment(initialAttachment);
        setUploadedFile(null);
        setIsMulti(false);
        setFileList([]);
        formik.resetForm();
    }

    const SaveAttachment = (values, setSubmitting) => {
        setUploading(fileList.length);
        setLoading(true);
        let index = 0;
  
        for (const x of fileList) {
            if (values.id > 0 || uploadedFile) {
                proposalAttachmentService.saveProposalAttachment(convertJsonToFormData({
                    ...values,
                    uploadedFile: x,
                    name: !isMulti && values.name ? values.name  : x.name,
                    description: !isMulti && values.description ? values.description: ''
                })).then(res => {
                    setUploaded(++index);
                    showAlert({ message: res.message, variant: 'info' })
                    loadTableData();
                    handleModalClose();
                }).catch(ex => {
                    showAlert({ message: ex.message, variant: 'error' })
                }).finally(() => {
                    setSubmitting(false);
                })
            } else if (uploadedFile == null) {
                showAlert({ message: 'Please upload a file before submitting the form', variant: 'info' })
                setSubmitting(false);
            }
        }

    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: selectedAttachment,
        validationSchema: ProposalAttachmentValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            SaveAttachment(values, setSubmitting);
        }
    });

    return (
        <div className="row">
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>File Attachment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        File
                                    </label>
                                    <div className="col-lg-9 col-xl-9">
                                        {
                                            selectedAttachment.id > 0 ?
                                                <>
                                                    <a
                                                        target="_blank"
                                                        href={constants.API_URL + selectedAttachment.filePath}
                                                        className="btn btn-info mr-2"
                                                    >
                                                        <span className="fa fa-eye"></span> View File
                                                    </a>
                                                </>
                                                :
                                                <>
                                                    <FilePond
                                                        allowMultiple={isMulti}
                                                        labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                                                        onupdatefiles={(file) => {
                                                            if (file.length > 0) {
                                                                let selectedFile = file[0].file;
                                                                setEditObj({ ...editObj, name: selectedFile.name });
                                                                setUploadedFile(selectedFile);
                                                                setFileList(file.map(x => x.file));
                                                            } else {
                                                                setUploadedFile([]);
                                                                setFileList([]);
                                                            }
                                                        }}
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={isMulti}
                                                                onChange={() => {
                                                                    setIsMulti(!isMulti)
                                                                }}
                                                                value="checkedB"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Multi File Upload"
                                                    />
                                                </>
                                        }
                                    </div>
                                </div>
                                {
                                    !isMulti &&
                                    <>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Name
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <div className="input-group input-group-lg input-group-solid">
                                                    <input
                                                        placeholder="Start typing..."
                                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                                        name="name"
                                                        {...formik.getFieldProps("name")}
                                                    />
                                                </div>
                                                {formik.touched.name && formik.errors.name ? (
                                                    <div className="invalid-feedback display-block">
                                                        {formik.errors.name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Description
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <div className="input-group input-group-lg input-group-solid">
                                                    <Form.Control as="textarea" rows="5"
                                                        placeholder="Start typing..."
                                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                                        name="description"
                                                        {...formik.getFieldProps("description")}
                                                    />
                                                </div>
                                                {formik.touched.description && formik.errors.description ? (
                                                    <div className="invalid-feedback display-block">
                                                        {formik.errors.description}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </>

                                }

                                <div className="form-group row">
                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                        Send to Client?
                                    </label>
                                    <div className="col-lg-9 col-xl-6">
                                        <div className="checkbox-list mt-lg-4">
                                            <label className="checkbox checkbox-primary">
                                                <input
                                                    checked={formik.values.sendToClient}
                                                    type="checkbox"
                                                    name="sendToClient"
                                                    {...formik.getFieldProps("sendToClient")}
                                                />
                                                <span></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                {
                                    uploading > 0 && <div className="container">
                                        <strong>{uploaded} / {uploading} uploaded.</strong>
                                    </div>
                                }
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save
                            {formik.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="col-lg-12 col-xxl-12 aes-admin-listing-page aes-admin-listing-page--proposal-attachments">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Proposal Attachments
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Proposal Attachments
                            </span>
                        </h3>
                        {
                            !isReadOnly &&
                            <div className="card-toolbar">
                                <button
                                    onClick={() => setIsModalOpen(true)}
                                    className="btn btn-success font-weight-bolder font-size-sm mr-3"
                                >
                                    <span className="svg-icon svg-icon-lg svg-icon-white">
                                        <SVG
                                            src={toAbsoluteUrl(
                                                "/media/svg/icons/Code/Plus.svg"
                                            )}
                                        />
                                    </span> Add Attachment
                                </button>
                            </div>
                        }

                    </div>
                    <div className="container-fluid aes-admin-listing">
                        <MUIDataTable
                            className="aes-admin-listing-surface"
                            data={data}
                            columns={columns}
                            options={{
                                responsive: 'standard',
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                setTableProps: () => ({
                                    className: 'aes-admin-listing-table',
                                }),
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateFromProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateFromProps, { ...alert.actions, ...confirmModal.actions })(ProposalAttachmentPage);
